import { z } from "zod";

export const addOrUpdateInterestedSchema = z.object({
  label: z.string().min(1, "Label is required"),
  priority: z.string().min(1, "Priority is required"),
});

export type AddOrUpdateInterestedFormData = z.infer<
  typeof addOrUpdateInterestedSchema
>;

export const defaultValues: AddOrUpdateInterestedFormData = {
  label: "",
  priority: "",
};
